/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import CardWithHeaderImage from '../../../Components/Card/cardWithHeaderImage/CardWithHeaderImage';
import cardImage1 from '../../../assets/images/png/abdominal.png';
import cardImage2 from '../../../assets/images/png/jointpain.png';
import cardImage3 from '../../../assets/images/png/covid-19.png';
import cardImage4 from '../../../assets/images/png/diettypes.png';
import { SectionHeadingSmall } from '../../../Components/Headings';
import AnchorLink from '../../../Components/button/ancerWithUnderline/anchorLink';
import { RightArrowWithBorder } from '../../../Components/icons';
import './exploreHealthMoreConditions.css';

function ExploreMoreHealthConditions() {
  const cardDatas = [
    {
      image: cardImage1,
      topic: 'پیٹ کا درد',
      desc: '',
      btnText: 'مزید پڑھ'
    },
    { image: cardImage2, topic: 'جوڑوں کا درد', desc: '', btnText: 'مزید پڑھ' },
    { image: cardImage3, topic: 'COVID-19', desc: '', btnText: 'مزید پڑھ' },
    { image: cardImage4, topic: 'غذا کی اقسام', desc: '', btnText: 'مزید پڑھ' }
  ];

  return (
    <section className="exploreHealthMoreConditions">
      <Container>
        <SectionHeadingSmall
          heading="صحت کے حالات پر مزید دریافت کریں۔"
          icon={<RightArrowWithBorder />}
          link={<AnchorLink to="/" text="سب دیکھیں" />}
        />
        <Row>
          {cardDatas.map((cardData, index) => (
            <Col md={3} key={index}>
              <CardWithHeaderImage {...cardData} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default ExploreMoreHealthConditions;
